import styled, { css } from 'styled-components';
import { RoundStatus } from '..';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  gap: 20px;

  button {
    background-color: #373245;
  }
`;

export const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    color: var(--color-point) !important;
  }
`;

export const DivBox = styled.div``;

export const CountBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  button {
    height: 100%;
    padding: 1rem;
  }
`;

export const DropdownBox = styled.div`
  div {
    background-color: #373245;
    color: #ccc;
    border: none;
    border-radius: 0.8rem;
  }

  // react library의 내부 클래스를 다룸 기본값 padding-right: 52px
  .Dropdown-control {
    padding-right: 26px;
  }
`;

export const ButtonBox = styled.div`
  height: 100%;
  display: flex;
  gap: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    height: 100%;
  }
`;
interface Props {
  color: string;
}

export const StyledLine = styled.div<Props>`
  width: 100%;
  text-align: center;
  border-bottom: 1px solid ${({ color }) => color};
  line-height: 0.1em;
  margin: 0px;
`;

export const EndTime = styled.div`
  padding: 10px;
  display: flex;
  gap: 10px;

  div > .arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #999;
    position: relative;
    top: 3px;
  }
`;

export const RoundGuideText = styled.div<{ roundStatus: RoundStatus }>`
  font-size: 12px;

  ${({ theme, roundStatus }) =>
    roundStatus === 'none' &&
    css`
      color: ${theme.palette.grayscale500};
    `}

  ${({ roundStatus }) =>
    roundStatus === 'expiration' &&
    css`
      color: #e13a3a;
    `}
`;

export const ModalButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 0 12px;
  padding: 0 12px 12px;

  button {
    width: 100%;
  }
`;
